<template>
  
  <div class="media single-media single-media-component" 
    @mouseover="hover = true"
    @mouseleave="hover = false">

    <div class="pic" :style="{backgroundImage: `url(${preview})`}"></div>

    <div class="info-wrapper" :class="{show: hover}">

      <div class="info">
        <span class="filename">{{media.nome}}</span>
      </div>

      <div class="actions">
        <button class="media-info" @click="show_info = true">Informazioni</button>
        <button class="delete" @click="delete_media = true">Elimina</button>
      </div>

    </div>

    <media-info v-if="show_info" :media="media"/>
    <delete-media v-if="delete_media" :media="media"/>

  </div>

</template>

<script>
import deleteMedia from './delete-media'
import mediaInfo from './media-info'
export default {

  components: {deleteMedia, mediaInfo},

  props: ['media'],

  data: function(){
    return {
      images: ['jpeg', 'jpg', 'png', 'svg', 'gif'],
      documents: ['pdf', 'docx', 'txt', 'csv', 'xmls'],
      document_preview: window.location.origin + '/media/document_placeholder.jpg',
      hover: false,
      delete_media: false,
      show_info: false
    }
  },

  computed: {

    preview: function(){

      if( _.indexOf( this.images, this.media.estensione ) > -1 ){
        return this.media.url;
      } else{
        return this.document_preview;
      }

    }

  },

  methods: {

    deleteMedia: function(){

      var vue = this;
      
      axios({
        method: "post",
        url: window.location.origin + '/data/media/delete',
        data: {
          id_media: vue.media.id
        }
      })
      .then(res => {
        
        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });
        vue.$destroy();

      })
      .catch(err => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: err.response.data.message
        });
        
      })

    }

  },

  beforeDestroy: function(){

    this.$el.parentElement.remove();

  }

}
</script>

<style scoped>
.media{
  width: 100%;
  height: auto;
  position: relative;
}
.media .pic{
  height: 0;
  width: 100%;
  padding-bottom: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.media .info{
  font-size: .9em;
  margin-top: .5em;
}
.info-wrapper{
  opacity: 0;
  transform: translateY(-10px);
  transition: all .15s linear;
}
.info-wrapper.show{
  opacity: 1;
  transform: translateY(0px);
}
.actions{
  margin-top: 5px;
}
button.media-info{
  color: white;
  background-color: var(--blue-message);
  border: 1px solid var(--blue-message);
}
button.media-info:hover{
  color: var(--blue-message);
  background-color: white;
}
button.delete{
  color: white;
  background-color: var(--red);
  border: 1px solid var(--red);
}
button.delete:hover{
  color: var(--red);
  background-color: white;
}
</style>